import AppWrapper from 'components/AppWrapper';
import { Formik } from 'formik';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { ChargingPolicy } from 'screens/GroupsAndPolicies/types';
import {
  Button,
  Container,
  Form,
  Grid,
  Header,
  Message,
  Segment,
} from 'semantic';
import { chargingPolicySchema } from 'screens/GroupsAndPolicies/validation';
import { FeatureFlag } from 'components';
import InputField from 'components/form-fields/formik/InputField';
import DropdownField from 'components/form-fields/formik/DropdownField';
import { useUser } from 'contexts/user';
import { PricingPreview } from 'screens/GroupsAndPolicies/ChargingPolicy/PricingPreview';
import { SessionThresholdsPreview } from 'screens/GroupsAndPolicies/ChargingPolicy/SessionThresholdsPreview';
import { SessionThresholdsModal } from 'screens/GroupsAndPolicies/ChargingPolicy/SessionThresholdsModal';

export const ChargingPolicyForm = () => {
  const { t } = useTranslation();

  // TODO: not a very nice solution? Maybe use React routes?
  const [pricingForm, setPricingForm] = React.useState(false);

  const { provider } = useUser();

  const submit = async (values: ChargingPolicy) => {
    console.log('submit', values);
  };

  return (
    <AppWrapper>
      <FeatureFlag feature="policies_and_groups">
        <Container>
          <Formik
            initialValues={
              {
                label: 'test',
                defaultTariff: {
                  descriptions: [{ name: 'test', language: 'en' }],
                },
                customTariffRules: [{}, {}, {}],
              } as ChargingPolicy
            }
            validationSchema={chargingPolicySchema}
            onSubmit={submit}>
            {({
              values,
              status,
              handleSubmit,
              handleReset,
              errors,
              setFieldValue,
            }) => (
              <Form>
                {errors && <Message error content={JSON.stringify(errors)} />}
                <Header
                  as="h1"
                  content={t(
                    'chargingPolicyForm.createChargingPolicy',
                    'Create Charging Policy'
                  )}
                />

                {status && <Message error content={status} />}

                <Header
                  as="h4"
                  content={t(
                    'chargingPolicyForm.generalInfoTitle',
                    'General Info'
                  )}
                />
                <Segment>
                  <InputField
                    name="label"
                    label={t('chargingPolicyForm.label', 'Name')}
                    required
                  />

                  <InputField
                    name="description"
                    label={t('chargingPolicyForm.description', 'Description')}
                    required
                  />

                  <DropdownField
                    name="currency"
                    selection
                    label={t('chargingPolicyForm.currency', 'Currency')}
                    options={
                      provider?.billingCurrencies.map((currency) => ({
                        key: currency,
                        value: currency,
                        text: currency,
                      })) || []
                    }
                  />
                </Segment>

                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Header
                        as="h4"
                        content={t(
                          'chargingPolicyForm.pricingTitle',
                          'Pricing'
                        )}
                      />
                    </Grid.Column>
                    {!Object.keys(values?.defaultTariff || {}).length &&
                      !values?.customTariffRules?.length && (
                        <Grid.Column floated="right" width={2}>
                          {/*TODO: visual alignment needs to be improved here*/}
                          <Button icon="edit" basic size="mini" />
                        </Grid.Column>
                      )}
                  </Grid.Row>
                </Grid>
                <PricingPreview values={values} />

                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Header
                        as="h4"
                        content={t(
                          'chargingPolicyForm.sessionThresholdsTitle',
                          'Session Thresholds'
                        )}
                      />
                    </Grid.Column>
                    <Grid.Column floated="right" width={2}>
                      {/*TODO: visual alignment needs to be improved here*/}

                      <SessionThresholdsModal
                        trigger={<Button icon="edit" basic size="mini" />}
                        values={values.sessionThresholds}
                        currency={values.currency}
                        onSubmit={(values) =>
                          setFieldValue('sessionThresholds', values)
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <SessionThresholdsPreview
                  values={values.sessionThresholds}
                  currency={values.currency}
                />

                {/*TODO: Reimbursement */}
                {/*TODO: Overrides */}
                {/*TODO: Policy Associations */}

                <Button
                  content={t('chargingPolicyForm.cancel', 'Discard')}
                  as="button"
                  style={{ marginLeft: '0' }} // TODO: look for better solution
                  onClick={handleReset}
                />

                <Button
                  content={t(
                    'chargingPolicyForm.createPolicy',
                    'Create Policy'
                  )}
                  as="button"
                  style={{ marginLeft: '0' }} // TODO: look for better solution
                  onClick={handleSubmit}
                />
              </Form>
            )}
          </Formik>
        </Container>
      </FeatureFlag>
    </AppWrapper>
  );
};
